export function handleDrillError(error: any) {
  const msg = (error?.message || '').toString();

  if (msg.toLowerCase().includes('limit reached') || msg.toLowerCase().includes('quota')) {
    return {
      title: 'Limit Reached',
      message: 'You have reached your AI drill generation limit. Upgrade your plan to continue.',
      action: 'upgrade',
    };
  }

  if (msg.toLowerCase().includes('authentication required') || msg.toLowerCase().includes('not authenticated')) {
    return {
      title: 'Authentication Required',
      message: 'Please log in to generate drills.',
      action: 'login',
    };
  }

  if (msg.toLowerCase().includes('failed to generate drill') || msg.toLowerCase().includes('generation failed')) {
    return {
      title: 'Generation Failed',
      message: 'Unable to generate drill. Please try again.',
      action: 'retry',
    };
  }

  return {
    title: 'Error',
    message: msg || 'An unexpected error occurred.',
    action: null,
  };
}
